<template>
  <v-wait for="creating preview">
    <template slot="waiting">
      <!-- <div id="loadingdiv">
        <img src="../../assets/images/loader.gif" />
      </div> -->
      <div id="loadingDiv" class="loadingDiv_analytics">
          <div class="loadersec">
            <div class="loader"></div>
          </div>
      </div>
    </template>
    <div
      v-bar="{scrollThrottle: 30, draggerThrottle: 30, preventParentScroll: true}"
      ref="vuebarContainer"
    >
      <div class="survey-wrap" @scroll="headerScroll">
        <div class="box-section">
          <div class="box" v-if="isPreviewScreen" style="display: none;">
            <div class="ribbon">
              <span>Preview</span>
            </div>
          </div>
          <div class="content_heightcal">
            <component v-bind:is="headerPreview" :if-shown-display="ifShownDisplay"></component>
            <component v-bind:is="contentPreview" @changeToEndScreen="changeToEndScreen" :site-title="siteTitle"></component>
            <component v-bind:is="startScreen" @changeContent="changeComponent" :site-title="siteTitle"></component>
            <component v-bind:is="endScreen" @changeToThankYouScreen="changeToThankYouScreen"></component>
            <component v-bind:is="thankYou" :site-title="siteTitle" :is-loop-survey="isLoopSurvey"></component>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="tapapp-logo">
      <a href="https://tapapp.co.uk" target="_blank" rel="noopener noreferrer">
        <img src="../../assets/images/appLogoT.png" />
      </a>
    </div> -->
    <component v-bind:is="footerPreview"></component>
  </v-wait>
</template>

<script>
var { frontHostName, redirectUrl } = require("../../../config/config.js");
import { mapGetters, mapActions } from "vuex";
import { EventBus } from "../../main";
import headerPreview from "./Header";
import contentPreview from "./Content";
import footerPreview from "./Footer";
import startScreen from "./StartScreen";
import endScreen from "./EndScreen";
import thankYou from "./Thankyou";

export default {
  components: {
    headerPreview,
    contentPreview,
    footerPreview,
    startScreen,
    endScreen,
    thankYou
  },
  data() {
    return {
      headerPreview: "headerPreview",
      contentPreview: "",
      footerPreview: "footerPreview",
      startScreen: "",
      endScreen: "",
      thankYou: "",
      startActivate: 1,
      endActivate: 1,
      questionStartEndPreview: {},
      isLoopSurvey: 0,
      ifShownDisplay: "",
      isPreviewScreen: true,
      siteTitle: ''
    };
  },
  computed: {
    ...mapGetters("previewSurvey", [
      "surveyMasterDetails",
      "surveyStartEndQuestions",
      "surveyDesignDetails"
    ])
  },
  mounted: async function() {
    this.$wait.start("creating preview");
    this.data = this.$session.getAll();
    console.log("$$$$$$$$$$$$$$$$$$$");
    console.log(this.data);
    this.data["in_survey_Id_normal"] = this.data.in_survey_Id;
    this.data["in_survey_Id"] = this.$route.params.id;
    if (this.$route.name == "ResponseForm") {
      this.isPreviewScreen = false;
      // this.$router.push({ name: "NotFound" });
      await this.getFullOnlineSurveyDetailsBySurveyId(this.data);
      await this.getFullSurveyDesignById(this.data);
      await this.getSurveyStartEndData(this.data).then(value => {
        this.questionStartEndPreview = this.$store.getters[
          "previewSurvey/surveyStartEndQuestions"
        ];
        this.startActivate = this.questionStartEndPreview["start"]
          ? this.questionStartEndPreview["start"]["in_status"]
          : "";
        this.endActivate = this.questionStartEndPreview["end"]
          ? this.questionStartEndPreview["end"]["in_status"]
          : "";

        // Check if START SCREEN is active or not
        // If active then hide header and content component
        if (!this.startActivate) {
          this.ifShownDisplay = "block";
          this.contentPreview = "contentPreview";
        } else {
          this.ifShownDisplay = "none";
          this.startScreen = "startScreen";
        }
      });
    } else {
      this.isPreviewScreen = true;
      this.data["request_type"] = "pre";
      await this.getFullSurveyDetailsBySurveyId(this.data);
      await this.getFullSurveyDesignById(this.data);
      await this.getSurveyStartEndData(this.data).then(value => {
        this.questionStartEndPreview = this.$store.getters[
          "previewSurvey/surveyStartEndQuestions"
        ];
        this.startActivate = this.questionStartEndPreview["start"]
          ? this.questionStartEndPreview["start"]["in_status"]
          : "";
        this.endActivate = this.questionStartEndPreview["end"]
          ? this.questionStartEndPreview["end"]["in_status"]
          : "";

        // Check if START SCREEN is active or not
        // If active then hide header and content component
        if (!this.startActivate) {
          this.ifShownDisplay = "block";
          this.contentPreview = "contentPreview";
        } else {
          this.ifShownDisplay = "none";
          this.startScreen = "startScreen";
        }
      });
    }

    if (this.surveyDesignDetails) {
      const customStyle = document.querySelector("body");
      customStyle.style.setProperty(
        "--textColor",
        this.surveyDesignDetails.text_color
      );
      customStyle.style.setProperty(
        "--buttonTextColor",
        this.surveyDesignDetails.button_text_color
      );
      customStyle.style.setProperty(
        "--buttonBgColor",
        this.surveyDesignDetails.button_color
      );
      customStyle.style.setProperty(
        "--backgroundImage",
        'url("' + this.surveyDesignDetails.bgUrl + '")'
      );
    }
    this.isLoopSurvey = this.surveyMasterDetails.in_loop_survey;
    document.body.classList.add("preview-survey");
    await this.getWhiteLabelDetails()
    this.$wait.end("creating preview");
  },
  // watch: {
  //   allSurveyDetails: {
  //     handler (val) {
  //       console.log(val)
  //       if(val.flag == 1) {
  //         this.st_survey_name = val.data[0]['st_survey_name']
  //         this.survey_design = JSON.parse(val.data[0]['survey_design_details']['st_survey_design_data'])
  //         //alert(this.survey_design.logo_align)
  //       } else if (val.flag == 0) {
  //         this.$awn.alert(val.msg)
  //       } else {
  //         this.$awn.alert(val.msg)
  //       }
  //     }
  //   }
  // },
  methods: {
    ...mapActions("previewSurvey", [
      "getFullSurveyDesignById",
      "getFullSurveyDetailsBySurveyId",
      "getFullOnlineSurveyDetailsBySurveyId",
      "getSurveyStartEndData"
    ]),
    hispec() {
      // var parts = window.location.href.split(".");
      let whitelabel = this.$session.get("whitelabel");
      var loc =
        frontHostName +
        process.env.CAKE_BASE_PATH +
        whitelabel +
        process.env.CAKE_SURVEY_PATH;
      // var loc = "http://" + location.hostname + process.env.CAKE_SURVEY_PATH;
      window.location.href = loc;
    },
    changeComponent() {
      this.startScreen = "";
      this.ifShownDisplay = "block";
      this.contentPreview = "contentPreview";
    },
    changeToEndScreen() {
      this.ifShownDisplay = "none";
      if (this.endActivate) {
        this.startScreen = "";
        this.contentPreview = "";
        this.endScreen = "endScreen";
      } else {
        // if (this.isLoopSurvey == 1) window.location.reload();
        // else {
          this.startScreen = "";
          this.contentPreview = "";
          this.endScreen = "";
          this.thankYou = "thankYou";
        // }
      }
    },
    changeToThankYouScreen() {
      this.startScreen = "";
      this.contentPreview = "";
      this.endScreen = "";
      this.thankYou = "thankYou";
    },
    headerScroll(evt) {
      setTimeout(() => {
        EventBus.$emit(
          "calculateScrollY",
          this.$vuebar.getState(this.$refs.vuebarContainer).barTop
        );
      }, 100);
    },
    async getWhiteLabelDetails() {
      var parts = window.location.href.split('.')
      // parts[0] = 'http://hispec';
      // parts[1] = 'hispecservices';
      // parts[2] = 'com/doyenhub';
      if (parts[0].includes('//')) parts[0] = parts[0].split('//')[1]
      let domain = parts[0]
      let whitelabel = this.$route.params.whitelabel
      let url = process.env.API_PATH + "/getDomainDetails";
      await axios
        .post(
          url,
          {
            st_subdomain: domain,
            st_whitelabel: whitelabel
          },
          {
            headers: { "Content-Type": "application/json" }
          }
        )
        .then(response => {
          if(response.data.data.isAllowPhotoUploads == 1) {
            this.$session.set("isAllowPhotoUploads", true);
            console.log('================isAllowPhotoUploads if');
            console.log(response.data.data.isAllowPhotoUploads);
            console.log(this.$session.get("isAllowPhotoUploads"));
            console.log('================');
          } else {
            this.$session.set("isAllowPhotoUploads", false);
            console.log('================isAllowPhotoUploads else');
            console.log(response.data.data.isAllowPhotoUploads);
            console.log(this.$session.get("isAllowPhotoUploads"));
            console.log('================');
          }
          if (response.data.flag === 1) {
            var designdata = response.data.data;
            console.log('================');
            console.log(designdata);
            console.log(this.surveyMasterDetails);
            this.siteTitle = (this.surveyMasterDetails.in_status == 1) ? this.surveyMasterDetails.st_survey_name + ' - ' + ((whitelabel != 'default') ? designdata.st_site_name + ' - ' : '') +  designdata.st_default_site_name : 'Form Preview';
            // Updating favicon according to whitelabel details
            if (designdata.favicon_image_url && designdata.favicon_image_url.length > 0) {
              const favicon = document.getElementById("favicon");
              favicon.href = designdata.favicon_image_url;
            }
            // this.siteTitle = ((designdata.st_default_site_name) ? ' - ' + this.domain + ((this.whitelabel != 'default') ? (':' + this.whitelabel + ' - ' + designdata.st_site_name) : '') + ' - ' + designdata.st_default_site_name : '');
          } else if (response.data.flag === 4) {
            console.log("invalid account name");
            this.$awn.alert("The page you requested does not exists.");
            var loc = location.host;
            var locArr = loc.split(".");
            loc = location.protocol + "//" + locArr[1] + "." + locArr[2];
            window.location.href = loc;
          } else {
            console.log("invalid url");
            this.$awn.alert("The page you requested does not exists.");
            window.location.href = redirectUrl;
          }
        })
        .catch();
    }
  }
};
</script>
<style lang="scss">
@import "vuetify/dist/vuetify.min.css";
@import "../../assets/css/scss/front-style.scss";
@import "../../assets/css/scss/custom-front-style.scss";
</style>



// WEBPACK FOOTER //
// src/components/Preview/Main.vue